<template>
<!-- 表格 -->
<div class="page tabSession">
    <!-- 下半部分表格 -->
    <!-- <h3 class="columnTit">
                <span>拍卖结果</span><a href="#" target="_blank">查看更多</a>
            </h3> -->
    <!-- 列表 -->
    <div class="aucResult">
        <div class="resultColTit flex">
            <span class="name">LOT号</span>
            <span class="number">拍品名称</span>
            <span class="company" v-if="pmstatus < 5">估价</span>
            <span class="company" v-if="pmstatus == 5">成交价</span>
        </div>
        <el-collapse v-model="activeName" :accordion="true">
            <el-collapse-item :name="index" v-for="(item, index) in epeciaList" :key="index">
                <template slot="title">
                    <div class="flex">
                        <span class="name">
                            <!-- <a href="#" target="_blank">2021年春季文物艺术品拍卖会（1）</a> -->
                            {{ item.detail.tlNumber  }}
                        </span>
                        <span class="number">
                            <a :href="'javascript:;'" v-if="$route.query.from == 1">{{ item.detail.workName }}</a>
                            <a :href="'/paimai-'+item.artCode+'?from=2'" v-else-if="$route.query.from == 2">{{ item.detail.workName }}</a>
                            <a :href="'/paimai-'+item.artCode" target="_blank" v-else>{{ item.detail.workName }}</a>
                        </span>
                        <span class="company item-red" v-if="pmstatus == 5">
                            <template v-if="isLogin">
                                <template v-for="(con,k) in item.pc_extra_info">
                                    <template v-if="con.type == 'price'">
                                        <div :key="k">
                                            <strong class="price" v-if="ifLogin > 0&&isMem==1">
                                                <template v-if="con.text!='未提供'">
                                                    {{con.smallText}} {{con.text}}
                                                </template>
                                                <template v-else>
                                                    {{con.text}}
                                                </template>
                                            </strong>
                                            <strong v-else-if="con.text=='未提供'"><a href="javascript:;" @click="gotoLogin" class="item-red">{{con.text}}</a></strong>
                                            <strong v-else><a href="javascript:;" @click="gotoLogin" class="item-red">{{con.smallText}}&nbsp;{{con.nonMemberText}}</a></strong>
                                        </div>

                                    </template>
                                    <!-- <strong class="price" :key="k" v-if="con.type == 'price' && ifLogin > 0&&isMem==1">{{con.smallText}} {{con.text}}</strong>
                             <strong :key="k" v-if="con.type == 'price' && !ifLogin > 0&&isMem!=1"><a  href="javascript:;" @click="gotoLogin" class="item-red">{{con.smallText}}&nbsp;{{con.nonMemberText}}</a></strong> -->
                                </template>
                            </template>
                            <template v-else><a href="javascript:;" @click="gotoLogin" class="item-red">请登录后查看</a></template>
                        </span>
                        <span v-else class="company item-red">
                            <template v-if="pmstatus < 5">
                                <template v-for="(con,k) in item.detail.extraInfo">
                                    <strong class="price" :key="k" v-if="con.type == 'gujia'">{{con.smallText}} {{con.text}}</strong>
                                </template>
                            </template>

                            <template v-if="pmstatus == 5">
                                <template v-for="(con,k) in item.detail.extraInfo">
                                    <strong class="price" :key="k" v-if="con.type == 'price'">{{con.smallText}} {{con.text}}</strong>
                                </template>
                            </template>

                        </span>
                    </div>
                </template>
            </el-collapse-item>
        </el-collapse>
    </div>
    <!-- 分页 -->

    <div class="paging">
        <el-pagination background :page-size="10" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout=" prev, pager, next" :current-page.sync="jumpVal" :total="num ? num : 0" :prev-text="'&lt; 上一页'" :next-text="'下一页 &gt;'">
        </el-pagination>
        <span class="total"><i>{{ currentPage }}</i>/{{ num ? Math.ceil(num / 10) : 0 }}</span>
        <div class="jumpBox">
            跳至
            <input type="text" class="inputJump" v-model="jumpVal" @input="changeNum" />
            页
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ["pageId", "status", 'num', 'epeciaList'],
    data() {
        return {
            input4: "",
            textShow: true,
            picShow: false,
            jumpVal: null,
            activeName: 5,
            currentPage: null, //当前页面
            selectList: [{
                    type: 0,
                    name: "图录号"
                },
                {
                    type: 0,
                    name: "估价"
                },
                {
                    type: 0,
                    name: "热门度"
                },
                {
                    type: 1,
                    name: "LOT号"
                },
            ],
            value: "",
            checkList: ["同步拍", "图文直播"],
            isLogin: 0
        };
    },
    computed: {
        pmstatus() {
            return this.status
        }
    },
    mounted() {
        this.jumpVal = this.pageId;
        this.currentPage = this.pageId;
        if (this.getCookie("_at_pt_0_")) {
            this.isLogin = 1
        }
    },
    methods: {
        //日期升降排序
        dataSort() {
            console.log("日期升序降序");
        },
        changeNum() {
            this.jumpVal =
                Number(this.jumpVal) < 0 || !Number(this.jumpVal) ?
                0 :
                this.jumpVal;

            this.jumpVal =
                // 判断不能超过总页码  超过则显示最大值
                this.jumpVal > Math.ceil(this.num / 10) ?
                Math.ceil(this.num / 10) :
                this.jumpVal;
            console.log(typeof this.jumpVal);
            this.currentPage = Number(this.jumpVal);
            this.$emit("pagelimt", this.currentPage);
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentPage = Number(val);
            this.$emit("pagelimt", this.currentPage);
        },
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            } else {
                return null;
            }
        },
        gotoLogin: function () {
            if (this.$route.query.from) {
                return false
            }
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        },
        formatPrice(num) {
            var arr = (num + '').split('.');
            var intSum = arr[0].replace(/\B(?=(?:\d{3})+$)/g, ','); //取到整数部分
            var fen = arr[1] ? '.' + arr[1] : ''
            var ret = intSum + fen;
            return ret;
        }

    },
};
</script>

<style lang="scss" scoped>
.tabSession {
    width: 1180px;
    margin: 0 auto;
}

// 搜素框
.aucResult {
    min-width: 1180px;
    margin: 0 auto;

    .resultColTit {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 14px;
        margin-left: 20px;
        margin-right: 20px;
    }

    .name {
        width: 108px;
        margin-right: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .number {
        width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .price {
        width: 100px;
    }

    .company {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /deep/.el-collapse {
        border-bottom: 0;
    }

    /deep/.el-collapse-item {
        .flex {
            width: 100%;
            padding: 0 20px;
            transition: .2s background-color ease-in-out;
        }

        .flex:hover {
            background-color: #eaf5e7;
            cursor: pointer;
        }
    }

    /deep/.el-collapse-item__header {
        border: 0;
        height: 50px;
        line-height: 50px;
        color: #262626;
        display: block;
    }

    /deep/.el-collapse-item__arrow {
        display: none;
    }

    a {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: .2s color ease-in-out;
    }

    a:hover {
        color: #329d15;
    }

    .item-red {
        color: #F5222D;
    }

    /deep/.el-collapse-item__wrap {
        background-color: #eaf5e7;
        border-bottom: 0;

        .el-collapse-item__content {
            padding-bottom: 0;
        }

        .sessionLink {
            border-top: 1px solid #d9d9d9;

            span {
                width: 49%;
                display: inline-block;
                color: rgba(0, 0, 0, 0.85);
                line-height: 22px;
                font-size: 14px;
                padding: 10px 0;
            }

            span:before {
                width: 8px;
                height: 8px;
                background-color: #329d15;
                display: inline-block;
                content: "";
                margin-right: 8px;
                border-radius: 50%;
            }

            span:hover {
                cursor: pointer;
                color: #329d15;
            }
        }
    }
}

// 分页样式
.paging {
    width: 1180px;
    margin: 40px auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    /deep/ .el-pagination {
        display: inline-block;
        text-align: center;

        button {
            padding: 0 10px;
            line-height: 28px;
            border: 1px solid #bfbfbf;
            border-radius: 4px;
            background-color: transparent;
            color: #262626;
        }

        .el-pager {
            font-size: 0;

            li {
                padding: 0 10px;
                line-height: 28px;
                border: 1px solid #bfbfbf;
                border-radius: 4px;
                background-color: transparent;
                transition: 0.2s all ease-in-out;
                font-weight: normal;
            }

            li:hover,
            .active,
            .el-pagination.is-background .el-pager li:not(.disabled).active {
                border-color: #329d15;
                background-color: #eaf5e7;
                color: #329d15;
            }

            .more {
                border: 0;
            }
        }
    }

    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        border-color: #329d15;
        background-color: #eaf5e7;
        color: #329d15;
    }

    .total {
        font-size: 14px;
        color: #595959;
        margin: 0 20px 0 15px;

        i {
            color: #329d15;
        }
    }

    .jumpBox {
        display: inline-block;
        line-height: 30px;
        color: #595959;
        font-size: 14px;

        .inputJump {
            width: 28px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid #bfbfbf;
            text-align: center;
            color: #595959;
            margin: 0 2px;
        }
    }
}

// 列表
.aucResult {
    min-width: 1180px;
    margin: 0 auto;

    .resultColTit {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 14px;
        margin-left: 20px;
        margin-right: 20px;
    }

    .name {
        width: 108px;
        margin-right: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .number {
        width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .price {
        width: 100px;
    }

    .company {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /deep/.el-collapse {
        border-bottom: 0;
    }

    /deep/.el-collapse-item {
        .flex {
            width: 100%;
            padding: 0 20px;
            transition: .2s background-color ease-in-out;
        }

        .flex:hover {
            background-color: #eaf5e7;
            cursor: pointer;
        }
    }

    /deep/.el-collapse-item__header {
        border: 0;
        height: 50px;
        line-height: 50px;
        color: #262626;
        display: block;
    }

    /deep/.el-collapse-item__arrow {
        display: none;
    }

    a {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: .2s color ease-in-out;
    }

    a:hover {
        color: #329d15;
    }

    /deep/.el-collapse-item__wrap {
        background-color: #eaf5e7;
        border-bottom: 0;

        .el-collapse-item__content {
            padding-bottom: 0;
        }

        .sessionLink {
            border-top: 1px solid #d9d9d9;

            span {
                width: 49%;
                display: inline-block;
                color: rgba(0, 0, 0, 0.85);
                line-height: 22px;
                font-size: 14px;
                padding: 10px 0;
            }

            span:before {
                width: 8px;
                height: 8px;
                background-color: #329d15;
                display: inline-block;
                content: "";
                margin-right: 8px;
                border-radius: 50%;
            }

            span:hover {
                cursor: pointer;
                color: #329d15;
            }
        }
    }
}
</style>
